import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * GA4 SPA route tracker.
 * Fires page_view on every React Router navigation.
 * Plays nicely with send_page_view:false in the base gtag config.
 */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
};

export default RouteTracker;
